import { useToast } from 'vue-toastification/composition';
import BaseToastTemplate from './BaseToastTemplate.vue';

export enum BaseToastTypeEnums {
  SUCCESS = 'success',
  INFO = 'info',
  DANGER = 'danger'
}

declare interface BaseToastProps {
  type: BaseToastTypeEnums;
  title: string;
  text: string;
}

export const createToastTemplate = (options: BaseToastProps) => ({
  component: BaseToastTemplate,
  props: {
    type: options.type,
    title: options.title,
    text: options.text,
  },
  toastClassName: 'base-toast-template',
});
